import React from "react";

/**
 * Shared ellipsis row-actions menu for data tables.
 * Styling comes from `_table-actions-menu.scss` (also applied to
 * existing `table td .dropdown` / `.dropup` markup).
 */
export default function TableActionsMenu({
  children,
  dropup = false,
  menuEnd = false,
  menuStyle,
  autoClose = true,
  ariaLabel = "Row actions",
  disabled = false,
  /** Escape overflow:hidden / sticky parents (e.g. table-responsive). */
  fixedPopper = true,
}) {
  const wrapperClass = dropup
    ? "dropup table-actions-menu"
    : "dropdown table-actions-menu";
  const menuClass = menuEnd
    ? "dropdown-menu dropdown-menu-end"
    : "dropdown-menu";
  const popperConfig = fixedPopper
    ? JSON.stringify({ strategy: "fixed" })
    : undefined;

  return (
    <div className={wrapperClass}>
      <button
        className="btn btn-sm no-caret"
        type="button"
        data-bs-toggle="dropdown"
        data-bs-auto-close={autoClose ? "true" : "false"}
        data-bs-popper-config={popperConfig}
        aria-label={ariaLabel}
        aria-expanded="false"
        disabled={disabled}
      >
        <i className="fa fa-ellipsis-h" aria-hidden="true" />
      </button>
      <div className={menuClass} style={menuStyle}>
        {children}
      </div>
    </div>
  );
}

/**
 * Optional action row with leading icon.
 * Use inside TableActionsMenu for Edit / Delete / custom actions.
 */
export function TableActionsItem({
  children,
  icon,
  to,
  onClick,
  danger = false,
  as: Component,
  type = "button",
  className = "",
  ...rest
}) {
  const classes = [
    "dropdown-item",
    danger ? "text-danger" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      {icon ? <i className={`${icon} fa-fw`} aria-hidden="true" /> : null}
      <span>{children}</span>
    </>
  );

  if (to) {
    const LinkComponent = Component;
    if (!LinkComponent) {
      throw new Error("TableActionsItem with `to` requires `as={Link}` (react-router).");
    }
    return (
      <LinkComponent to={to} className={classes} {...rest}>
        {content}
      </LinkComponent>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick} {...rest}>
      {content}
    </button>
  );
}
